// // Search Page JS
window.HomePreviewObject = function () {
    //Home Design Popout - Controller
    var $previewButtons = $('.home-design-btn, .searchResultLink, .display-listing');
    var $grids = $('.search-results-container, .main-grid-container, .home-design-page-grid');
    var $isAlternative = $('.display-home-popout-content');
    var $contentElements = $('.home-design-popout-content, .search-results-content');
    var homepreview_obj = {
        //page interactivity
        eventHandlers: function () {
            var self = this;

            //Event Handlers
            $previewButtons.unbind('click').on('click', function (event) {
                event.preventDefault();
                self.openPopout($(this).data('preview-link'));
            });

            $('.enquire-now').on('click', function () {
                var $idName = $(this).data('class') + 'ID';
                var $formID = '#TotemForm_GeneralEnquiryForm_' + $idName;
                var $enquiryID = $(this).data('id');

                setTimeout(function () {
                    $($formID).val($enquiryID);
                }, 1000);
            });
        },

        openPopout: function (previewLink) {
            window.location = previewLink;
        },

        checkUrlLocation: function () {
            var self = this;
            setTimeout(function () {
                var url = new URL(window.location.href);
                if (url.searchParams) {
                    var previewId = url.searchParams.get('homepreview');

                    if (previewId && previewId.length > 0) {
                        var pageClass = $(
                            '.display-listing,.searchResultLink[data-id="' +
                            previewId +
                            '"],.home-design-content[data-id="' +
                            previewId +
                            '"], .home-design-btn[data-id="' +
                            previewId +
                            '"]'
                        ).data('class');
                        self.openPopout(previewId, pageClass);
                    }
                }
            }, 100);
        },

        onReady: function () {
            this.eventHandlers();
            this.checkUrlLocation();
        }
    };

    return homepreview_obj;
};

$(function () {
    new window.HomePreviewObject({}).onReady();
});

$(document).ready(function () {
    if ($('.home-preview-page').length) {
        $('.HomeDesignPage').addClass('add-overflow-y-hidden');
        $('.footer').addClass('footer-visibility-toggle');
    }

    const $variantSelectors = $('.home-preview-page ul > li.variant-selector');

    const $floorSelectors = $('li.current-floor[data-floor]');

    const decodeHtmlEntities = (htmlEncodedText) => {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = htmlEncodedText;
        return textArea.value;
    };

    const setActiveVariant = (variantData) => {
        $('.variant-text').each((index, ele) => {
            const key = ele.getAttribute('data-variant-type');
            if (variantData.hasOwnProperty(key)) {
                ele.innerText = variantData[key];
            }
        });

        const variantId = variantData.ID;
        $('.variant-image').each((index, ele) => {
            const key = ele.getAttribute('data-variant');
            if (key == variantId) {
                ele.classList.remove('hide');
            }
            else {
                ele.classList.add('hide');
            }
        });

        $variantSelectors.each((index, ele) => {
            const key = ele.getAttribute('data-variant-id');
            if (key == variantId) {
                ele.classList.add('selected');
            }
            else {
                ele.classList.remove('selected');
            }
        });

        $('#inclusionPanel .variant-inclusions').each((index, ele) => {
            const key = ele.getAttribute('data-variant-id');
            if (key == variantId) {
                ele.classList.remove('uk-hidden');
            }
            else {
                ele.classList.add('uk-hidden');
            }
        });

        $('.variant-selector-container .variant-selections > div[data-variant-id]').each((index, ele) => {
            const key = ele.getAttribute('data-variant-id');
            if (key == variantId) {
                ele.classList.add('variant-selected');
            }
            else {
                ele.classList.remove('variant-selected');
            }
        });
    };

    $variantSelectors.on('click', (event) => {
        const liElement = event.target;
        const data = JSON.parse(decodeHtmlEntities(liElement.getAttribute('data-variant')));

        setActiveVariant(data);
    });

    const $selContainers = $('.variant-selector-container');
    $selContainers.attr('data-open', 'false');

    $selContainers.on('click', (event) => {
        const container = event.target.closest('.variant-selector-container');
        const selections = container.querySelector('.variant-selections');

        if (event.target.parentElement === selections) {
            const data = JSON.parse(decodeHtmlEntities(event.target.getAttribute('data-variant')));
            setActiveVariant(data);
        }

        selections.classList.toggle('uk-hidden');
        const isOpen = !selections.classList.contains('uk-hidden');
        container.setAttribute('data-open', isOpen ? 'true' : 'false');

        if (isOpen) {
            const closeEle = document.createElement('div');
            closeEle.className = 'variant-select-close';
            selections.parentElement.insertBefore(closeEle, selections);
        }
        else {
            const closeEle = container.querySelector('.variant-select-close');
            if (closeEle) {
                closeEle.parentElement.removeChild(closeEle);
            }
        }
    });

    $floorSelectors.on('click', (event) => {
        const selectedFloorButton = event.target;
        const thisContainer = selectedFloorButton.closest('div.variant-image');
        const variantId = thisContainer.getAttribute('data-variant');
        const selectedFloor = selectedFloorButton.getAttribute('data-floor');

        // Should find 2: mobile and desktop
        $(`div.variant-image[data-variant="${variantId}"]`).each((index, containerElement) => {
            containerElement.querySelectorAll('ul.floorplan-switcher-controls > li.current-floor[data-floor]').forEach((ele) => {
                if (ele.getAttribute('data-floor') === selectedFloor) {
                    ele.classList.add('selected');
                }
                else {
                    ele.classList.remove('selected');
                }
            });

            containerElement.querySelectorAll('div.floorplan-content > div.floorplan-content-wrapper[data-floor]').forEach((ele) => {
                if (ele.getAttribute('data-floor') === selectedFloor) {
                    ele.classList.remove('hide');
                }
                else {
                    ele.classList.add('hide');
                }
            });
        });
    });

    // Update the nav selections on the bottom of mobile view when scrolling
    let intersectStates = {};
    const intersectCallback = (entries, observer) => {
        entries.forEach((entry) => {
            const entryElement = entry.target;
            intersectStates[entryElement.getAttribute('data-observer-name')] = entry;
        });

        if (intersectStates.enquireButton && intersectStates.contactForm) {
            if (!intersectStates.enquireButton.isIntersecting && !intersectStates.contactForm.isIntersecting) {
                $('.side-enquire-btn').addClass('show-enquire-btn');
            } else {
                $('.side-enquire-btn').removeClass('show-enquire-btn');
            }
        }

        const filteredStates = {
            ...intersectStates
        };
        delete filteredStates.enquireButton;
        delete filteredStates.contactForm;
        const keys = Object.keys(filteredStates);

        for ( let i = 0; i < keys.length; i++ ) {
            if (filteredStates[keys[i]].isIntersecting === true) {
                let compareWithNext = false;

                if (i < keys.length - 1) {
                    if (filteredStates[keys[i + 1]].isIntersecting === true) {
                        compareWithNext = true;
                    }
                }

                let indexToSet = i;

                // if 2 elements are onscreen, then compare which is "more" onscreen
                if (compareWithNext) {
                    const rectHeight1 = filteredStates[keys[i]].intersectionRect.height;
                    const rectHeight2 = filteredStates[keys[i + 1]].intersectionRect.height;

                    if (rectHeight2 > rectHeight1) {
                        indexToSet = i + 1;
                    }
                }

                $(`a.nav-icons[href]`).removeClass('selected');
                $(`a.nav-icons[href$="${keys[indexToSet]}"]`).addClass('selected');
                break;
            }
        }
    };

    const intersectObserver = new IntersectionObserver(intersectCallback, { threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6] });

    $('[data-observer-name]').each((index, element) => {
        intersectObserver.observe(element);
    });

    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS) {
        $('.ios-nav').each(function() {
            if ($(this).hasClass('inclusion-icon')) {
                $(this).attr('uk-scroll', 'offset: 32');
            } else if ($(this).hasClass('floorplan-icon')) {
                $(this).attr('uk-scroll', 'offset: 40');
            } else if ($(this).hasClass('house-icon')) {
                $(this).attr('uk-scroll', 'offset: 50');
            } else if ($(this).hasClass('enquire-icon')) {
                $(this).attr('uk-scroll', 'offset: 32');
            } else {
                $(this).attr('uk-scroll', 'offset: 0');
            }
        });
    }
});
